import React from 'react';
import {
  FaBuilding,
  FaEnvelope,
  FaPhone,
  FaEdit,
  FaSave,
  FaTimes,
} from 'react-icons/fa';
import { useToastMessages } from '../../components/MessageToast/MessageToast';

const CompanyDetails = ({
  userData,
  setUserData,
  companyEdit,
  setCompanyEdit,
  handleCompanySave,
}) => {
  const { showSuccess, showError, ToastContainer } = useToastMessages();

  const handleSave = async () => {
    try {
      await handleCompanySave();
      showSuccess(
        'Informațiile despre companie au fost actualizate cu succes!',
      );
    } catch (error) {
      showError('A apărut o eroare la salvarea datelor companiei.');
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-8 rounded-2xl shadow-lg border border-indigo-100">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 bg-indigo-500 text-white flex items-center justify-center rounded-xl shadow-lg">
            <FaBuilding className="text-xl" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800">
              Detalii Companie
            </h2>
            <p className="text-gray-600">
              Gestionează informațiile companiei tale
            </p>
          </div>
        </div>

        {companyEdit ? (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <FaBuilding className="text-indigo-500" />
                  Nume Companie
                </label>
                <input
                  type="text"
                  value={userData?.company || ''}
                  onChange={(e) =>
                    setUserData((prev) => ({
                      ...prev,
                      company: e.target.value,
                    }))
                  }
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  placeholder="Introduceți numele companiei"
                />
              </div>
              <div className="space-y-2">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                  <FaEnvelope className="text-indigo-500" />
                  Email Companie
                </label>
                <input
                  type="email"
                  value={userData?.email || ''}
                  onChange={(e) =>
                    setUserData((prev) => ({
                      ...prev,
                      email: e.target.value,
                    }))
                  }
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                  placeholder="email@compania.ro"
                />
              </div>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                onClick={handleSave}
                className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105 shadow-lg"
              >
                <FaSave />
                Salvează
              </button>
              <button
                onClick={() => setCompanyEdit(false)}
                className="flex items-center gap-2 bg-gray-500 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-medium transition-all"
              >
                <FaTimes />
                Anulează
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <FaBuilding className="text-indigo-500" />
                  <span className="font-semibold text-gray-700">
                    Nume Companie
                  </span>
                </div>
                <p className="text-lg text-gray-800 font-medium">
                  {userData?.company || 'Nu este specificat'}
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <FaEnvelope className="text-indigo-500" />
                  <span className="font-semibold text-gray-700">Email</span>
                </div>
                <p className="text-lg text-gray-800 font-medium">
                  {userData?.email || 'Nu este specificat'}
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <FaPhone className="text-indigo-500" />
                  <span className="font-semibold text-gray-700">Telefon</span>
                </div>
                <p className="text-lg text-gray-800 font-medium">
                  {userData?.phone || 'Nu este specificat'}
                </p>
              </div>
            </div>

            <button
              onClick={() => setCompanyEdit(true)}
              className="flex items-center gap-2 bg-indigo-500 hover:bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium transition-all transform hover:scale-105 shadow-lg"
            >
              <FaEdit />
              Modifică Datele
            </button>
          </div>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default CompanyDetails;
